import { render, staticRenderFns } from "./RigheDistintaValidazioneConsumi.vue?vue&type=template&id=0bb08484&scoped=true"
import script from "./RigheDistintaValidazioneConsumi.vue?vue&type=script&lang=ts"
export * from "./RigheDistintaValidazioneConsumi.vue?vue&type=script&lang=ts"
import style0 from "./RigheDistintaValidazioneConsumi.vue?vue&type=style&index=0&id=0bb08484&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb08484",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bb08484')) {
      api.createRecord('0bb08484', component.options)
    } else {
      api.reload('0bb08484', component.options)
    }
    module.hot.accept("./RigheDistintaValidazioneConsumi.vue?vue&type=template&id=0bb08484&scoped=true", function () {
      api.rerender('0bb08484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/consumi/RigheDistintaValidazioneConsumi.vue"
export default component.exports